"use strict";

import { MY_GARAGE_URL } from '@autoguru/global-configs';
export const loggedInDashboardUrl = `${MY_GARAGE_URL}/:slug/booking`;
export { default as DEPortalHome } from '../scenes/Landing';